var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.166 75V70.8333C29.166 59.3275 38.4934 50 49.9994 50C61.5052 50 70.8327 59.3275 70.8327 70.8333V75",
    stroke: "#1884C7",
    strokeWidth: 6.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16602 74.9997V70.833C4.16602 63.9293 9.76247 58.333 16.666 58.333",
    stroke: "#1884C7",
    strokeWidth: 6.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95.834 74.9997V70.833C95.834 63.9293 90.2377 58.333 83.334 58.333",
    stroke: "#1884C7",
    strokeWidth: 6.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50 50C56.9037 50 62.5 44.4037 62.5 37.5C62.5 30.5965 56.9037 25 50 25C43.0962 25 37.5 30.5965 37.5 37.5C37.5 44.4037 43.0962 50 50 50Z",
    stroke: "#1884C7",
    strokeWidth: 6.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6673 58.3337C21.2697 58.3337 25.0007 54.6028 25.0007 50.0003C25.0007 45.3978 21.2697 41.667 16.6673 41.667C12.0649 41.667 8.33398 45.3978 8.33398 50.0003C8.33398 54.6028 12.0649 58.3337 16.6673 58.3337Z",
    stroke: "#1884C7",
    strokeWidth: 6.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3333 58.3337C87.9358 58.3337 91.6667 54.6028 91.6667 50.0003C91.6667 45.3978 87.9358 41.667 83.3333 41.667C78.7308 41.667 75 45.3978 75 50.0003C75 54.6028 78.7308 58.3337 83.3333 58.3337Z",
    stroke: "#1884C7",
    strokeWidth: 6.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame2);
export default __webpack_public_path__ + "static/media/Frame2.ee1715711b1ed7e469f227d789c6a99b.svg";
export { ForwardRef as ReactComponent };